import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Icon,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@qw/ui";
import { type ComponentProps, type FC, useCallback } from "react";

import { useChatForm } from "./use-chat-form";

interface ChatFormPlusMenuProps extends ComponentProps<typeof Button> {}

export const ChatFormPlusMenu: FC<ChatFormPlusMenuProps> = (props) => {
  const { dropzone, canEdit } = useChatForm();

  const handleAddFiles = useCallback(() => {
    if (!canEdit) {
      return;
    }
    dropzone.open?.();
  }, [canEdit, dropzone]);

  return (
    <DropdownMenu>
      <Tooltip>
        <TooltipTrigger asChild>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" size="xs" display="icon" type="button" disabled={!canEdit} {...props}>
              <Icon icon="add_2" />
            </Button>
          </DropdownMenuTrigger>
        </TooltipTrigger>
        <TooltipContent>More options</TooltipContent>
      </Tooltip>

      <DropdownMenuContent side="top" align="start">
        <DropdownMenuItem onSelect={handleAddFiles}>
          <Icon icon="attach_file" /> Add files
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
